<template>
  <!-- eslint-disable max-len -->
  <WdsAlert
    warning
    :title="$t('Note')"
    :description="$t('Changing your :vatTerminology registration will only impact your future bills. Contact us if you need changes made to any of your existing bills.', { vatTerminology })"
  />
</template>

<script>
import { WdsAlert } from '@worksome/wds-components'

export default {
  components: {
    WdsAlert,
  },

  computed: {
    vatTerminology() {
      return vatTerminology
    },
  },
}
</script>
